import { Observable } from 'rxjs/Rx';
import { locale } from 'moment';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import 'rxjs/add/operator/take';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { environment } from '../../environments/environment';
import { HttpClient } from './http-client';


@Injectable()
export class FirebaseMessagingService {

  currentMessage = new BehaviorSubject(null);
  private messaging;

  constructor(private httpClient: HttpClient) {
    // firebase.initializeApp({
    //   'messagingSenderId': '668822351022'
    // });
    //
    // this.messaging = firebase.messaging();
    //
    // this.messaging.onMessage((payload) => {
    //   console.log("Message received. ", payload);
    //   this.currentMessage.next(payload)
    // });
    //
    // this.messaging.onTokenRefresh( () => {
    //   this.requestPermissions(true);
    // });
    //
    // if(navigator.serviceWorker){
    //   navigator.serviceWorker.register('firebase-messaging-sw.js')
    //     .then((registration) => {
    //       this.messaging.useServiceWorker(registration);
    //     });
    // }
  }

  // onNewFirebaseMessage(){
  //   return this.currentMessage.asObservable();
  // }
  //
  // deleteToken(): Observable<string> {
  //   let token = localStorage.getItem('firebaseToken');
  //   localStorage.removeItem('firebaseToken');
  //   return Observable.empty<string>();
  // }
  //
  // requestPermissions(refresh: boolean = false): Observable<string> {
  //
  //   return Observable.fromPromise(
  //     this.messaging.requestPermission()
  //     .then(() => {
  //       console.log('Notification permission granted.');
  //       return this.messaging.getToken()
  //     })
  //     .then(token => {
  //       localStorage.setItem('firebaseToken', token);
  //       if(refresh){
  //         let userId = localStorage.getItem('userId');
  //         this.deleteFirebaseToken(false, userId).subscribe(response => {
  //           this.registerFirebaseToken(token);
  //         });
  //       }
  //       return token;
  //     })
  //     .catch((err) => {
  //       console.log('Unable to get permission to notify.', err);
  //     })
  //   );
  // }
  //
  // deleteFirebaseToken(isMobile: boolean= false, firebaseToken: any){
  //   return this.httpClient.post(`/api/user/delete-push-token/`, {
  //       Mobile: isMobile,
  //       PushToken: firebaseToken
  //   });
  // }
  //
  // registerFirebaseToken(token: string){
  //   return this.httpClient.post(`/api/user/register-push-token/`, {
  //     PushToken: token,
  //     userId: localStorage.getItem('userId'),
  //     Mobile: false
  //   });
  // }
  //
  sendToAnalytics(finalURL): void {

  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/firebase-messaging.service.ts